import { render, staticRenderFns } from "./BindMode.vue?vue&type=template&id=2e721aca&scoped=true"
import script from "./BindMode.vue?vue&type=script&lang=js"
export * from "./BindMode.vue?vue&type=script&lang=js"
import style0 from "./BindMode.vue?vue&type=style&index=0&id=2e721aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e721aca",
  null
  
)

export default component.exports